export default {"src":"/polygon/_next/static/media/polygon.732bb206.svg","height":10,"width":12};